var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"baseSearchBar",class:[_vm.$style.baseSearchBarBox]},[_c('form',{class:[_vm.$style.baseSearchBar,{ isFixed: _vm.isMenuFixed }],on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }